<template>
  <div class="accounts">
    <template v-if="this.total < 0">
      <div class="alert alert-info" role="alert" style="margin-top: 30px">
        Searching...
      </div>
    </template>
    <template v-else-if="this.total > 0">
      <div
        class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
      >
        <h1 class="h2">Found {{ total }} accounts</h1>
      </div>
      <div class="table-responsive">
        <table class="table table-striped table-hover">
          <thead>
            <tr>
              <td>View profile</td>
              <td>Email</td>
              <td>Domains</td>
              <td class="text-center">Is Premium?</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="account in items" v-bind:key="account.email">
              <td>
                <router-link
                  :to="{
                    name: 'account-details',
                    params: { email: account.email },
                  }"
                >
                  {{ getName(account) | capitalize }}
                  <span v-if="account.locked">&#x1f512;</span>
                </router-link>
                <span v-if="account.plan" class="ml-2 badge badge-info">{{
                  account.plan.display
                }}</span>
              </td>
              <td>
                <router-link
                  :to="{
                    name: 'account-details',
                    params: { email: account.email },
                  }"
                  >{{ account.email }}</router-link
                >
              </td>
              <td>
                {{ account.domains | pluralize("domain") }}
              </td>
              <td class="text-center">
                <template v-if="account.premium"
                  ><i class="icon ion-md-heart"></i
                ></template>
                <template v-else
                  ><i class="icon ion-md-close-circle-outline"></i
                ></template>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="2">
                <template v-if="this.offset > 0">
                  <a
                    href="javascript:;"
                    title="View previous page"
                    v-on:click="previousPage"
                    class="btn btn-primary btn-sm"
                    >Previous</a
                  >
                </template>
              </td>
              <td colspan="2" class="text-right">
                <template v-if="this.offset + this.limit < this.total">
                  <a
                    href="javascript:;"
                    title="View next page"
                    v-on:click="nextPage"
                    class="btn btn-primary btn-sm"
                    >Next</a
                  >
                </template>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </template>
    <template v-else>
      <template v-if="$route.query.qs">
        <div class="alert alert-warning" role="alert" style="margin-top: 30px">
          No account found. Please use the search bar at the top to search for
          accounts.
        </div>
      </template>
      <template v-else>
        <div class="alert alert-primary" role="alert" style="margin-top: 30px">
          Use the search bar at the top to search for users.
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import { formatHttpError } from "../utils/errors";

export default {
  data() {
    return {
      total: -1,
      items: [],
      offset: 0,
      limit: 20,
    };
  },
  created() {
    this.search(true);
  },
  methods: {
    getName(account) {
      if (account.company_name) {
        return account.company_name;
      }
      return account.email
        .split("@")[0]
        .replace(".", " ")
        .replace("-", " ")
        .replace("_", " ")
        .replace("+", " ");
    },
    search(redirect) {
      this.total = -1; //resets the state to searching
      if (!this.$route.query.qs) {
        this.items = [];
        this.total = 0;
        return null;
      }

      this.$http
        .post("accounts", {
          value: this.$route.query.qs,
          offset: this.offset,
          limit: this.limit,
        })
        .then(
          (response) => {
            if (redirect && response.body.total === 1) {
              this.$router.push({
                name: "account-details",
                params: { email: response.body.items[0].email },
              });
            } else {
              this.total = response.body.total;
              this.items = response.body.items;
              this.limit = response.body.limit;
            }
          },
          (response) => {
            if (response.status === 401) return;
            alert(formatHttpError(response));
          },
        );
    },
    nextPage() {
      this.offset += this.limit;
      this.search(false);
    },
    previousPage() {
      this.offset -= this.limit;
      if (this.offset < 0) {
        this.offset = 0;
      }
      this.search(false);
    },
  },
  beforeRouteUpdate(to, from, next) {
    next();
    this.search(true);
  },
};
</script>
